import { render } from "./Parallax.vue?vue&type=template&id=1de039b9&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"

import "./Parallax.vue?vue&type=style&index=0&id=1de039b9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de039b9"],['__file',"src/components/mdbvue/pro/CSS/Parallax.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de039b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de039b9', __exports__)) {
    api.reload('1de039b9', __exports__)
  }
  
  module.hot.accept("./Parallax.vue?vue&type=template&id=1de039b9&scoped=true", () => {
    api.rerender('1de039b9', render)
  })

}


export default __exports__